var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoiEditShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9826 16.4874H12.1829C9.07138 16.4874 6.36968 18.2422 5.01352 20.8162C4.99421 20.5755 4.98438 20.3322 4.98438 20.0867C4.98438 15.1171 9.01301 11.0885 13.9826 11.0885V6.58936L22.9808 13.7879L13.9826 20.9865V16.4874Z",
    fill: "#1A6263"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiEditShare);
export default __webpack_public_path__ + "static/media/PoiEditShare.c4deb6adba9503a36261148b82288363.svg";
export { ForwardRef as ReactComponent };